import { render, staticRenderFns } from "./CreateArticleTextarea.vue?vue&type=template&id=da8b1fbc"
import script from "./CreateArticleTextarea.vue?vue&type=script&lang=js"
export * from "./CreateArticleTextarea.vue?vue&type=script&lang=js"
import style0 from "./CreateArticleTextarea.vue?vue&type=style&index=0&id=da8b1fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports